<script lang="ts">
export const elTabStatuses = ['active', 'inactive', 'default'] as const;
export const elTabColors = ['primary', 'secondary'] as const;
export type ElTabStatues = (typeof elTabStatuses)[number];
export type ElTabColors = (typeof elTabColors)[number];
</script>

<script lang="ts" setup>
import ElBadge from '@/ElBadge.vue';
const {
  color = 'primary',
  label,
  status,
  badge,
} = defineProps<{
  label: string;
  status: ElTabStatues;
  color?: ElTabColors;
  badge?: {
    visible: boolean;
    value?: string;
  };
}>();

const emit = defineEmits<{
  (event: 'click'): void;
}>();
</script>

<template>
  <div
    class="group relative px-4 pt-2 pb-3 text-center text-sm transition-colors"
    :class="{
      'cursor-not-allowed': status === 'inactive',
      'cursor-pointer': status !== 'inactive',
    }"
    @click="status === 'inactive' || emit('click')"
  >
    <div class="relative flex flex-row justify-center items-start gap-2">
      <span
        :class="{
          'font-semibold': status === 'active',
          'text-neutral-inactive': status === 'inactive',
          'text-neutral-lighter': status === 'default',
          'text-primary-active': status === 'active' && color === 'primary',
          'text-secondary-active': status === 'active' && color === 'secondary',
          'group-hover:text-primary-hover group-active:text-primary-pressed': status !== 'inactive' && color === 'primary',
          'group-hover:text-secondary-hover group-active:text-secondary-pressed': status !== 'inactive' && color === 'secondary',
        }"
      >
        {{ label }}
      </span>
      <div v-if="badge?.visible && status !== 'inactive'">
        <ElBadge :value="badge.value" :color="color" />
      </div>
    </div>
    <div
      v-if="status !== 'inactive'"
      class="absolute bottom-0 left-0 h-[1px] w-full"
      :class="{
        'group-hover:bg-primary-hover group-active:bg-primary-pressed': color === 'primary',
        'group-hover:bg-secondary-hover group-active:bg-secondary-pressed': color === 'secondary',
        'bg-primary-active': status === 'active' && color === 'primary',
        'bg-secondary-active': status === 'active' && color === 'secondary',
      }"
    ></div>
  </div>
</template>
